"use strict";

exports.__esModule = true;
exports.default = void 0;
var _v = _interopRequireDefault(require("uuid/v1"));
var _actionTypes = require("./actionTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const initial = {
  errors: []
};
const reducer = (state = initial, action) => {
  const uuid = (0, _v.default)();
  switch (action.type) {
    case _actionTypes.CREATE_BASE_FAILURE:
      return {
        ...state,
        errors: [...(state.errors ? state.errors : []), {
          ...action.data,
          Timestamp: new Date().toISOString(),
          Id: uuid
        }]
      };
    case _actionTypes.DELETE_BASE_FAILURE:
      return {
        ...state,
        errors: state.errors.filter(error => error.Id !== action.data.Id)
      };
    default:
      return state;
  }
};
var _default = exports.default = reducer;
module.exports = exports.default;